module.exports = __webpack_public_path__ + "static/img/03.1ce8d9ff.png";